<template>
  <v-container
    style="margin-bottom: 100px;"
  >
    <v-img
      src="img/gift.svg"
      min-height="188px"
      max-width="200px"
      class="mx-auto mt-8 mb-12"
    />

    <div
      class="text-center"
    >
      <h1
        class="display-2 font-weight-bold mb-6 primary--text"
      >
        Ai ettien että!
      </h1>

      <p
        class="primary--text body-2"
      >
        Sinful.fi kokosi meille sytyttävän setin kesän kovimpia tarjouksia.
        Näistä irtoaa inspiraatiota sessioon jos toiseenkin.
        <br><br>
      </p>
    </div>

    <div
      v-for="(banner, i) in banners"
      :key="i"
      class="mb-6"
    >
      <v-subheader>
        {{ banner.title }}
      </v-subheader>

      <v-card
        :href="banner.targetSrc"
        target="_blank"
      >
        <v-img
          :src="banner.src"
        />

        <v-card-actions>
          <v-btn
            block
            text
            large
            target="_blank"
            :href="banner.targetSrc"
          >
            Avaa tarjous
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  computed: {
    banners() {
      return [
        {
          title: 'Bestsellerit',
          src: '/img/sinful/best_sellers.jpg',
          targetSrc: 'https://click.adrecord.com?c=37019&p=956&url=https%3A//www.sinful.fi/seksilelut/suosikkilelut/myydyimmat-seksilelut',
        },
        {
          title: 'Testivoittajat',
          src: '/img/sinful/test_winners.jpg',
          targetSrc: 'https://click.adrecord.com?c=37019&p=956&url=https%3A//www.sinful.fi/seksilelut/suosikkilelut/testeja-voittaneet-seksilelut',
        },
        {
          title: 'Jotain edullista',
          src: '/img/sinful/3_price_25.jpeg',
          targetSrc: 'https://click.adrecord.com?c=37019&p=956&url=https%3A//www.sinful.fi/seksilelut/suosikkilelut/3-kpl-25',
        },
        {
          title: 'Paras hinta-laatu-sytytys —suhde',
          src: '/img/sinful/3_price_50.jpeg',
          targetSrc: 'https://click.adrecord.com?c=37019&p=956&url=https%3A//www.sinful.fi/seksilelut/suosikkilelut/3-kpl-50',
        },
        {
          title: 'Laadukkaammat setit',
          src: '/img/sinful/3_price_80.jpeg',
          targetSrc: 'https://click.adrecord.com?c=37019&p=956&url=https%3A//www.sinful.fi/seksilelut/suosikkilelut/3-kpl-80',
        },
        {
          title: 'Uutuudet',
          src: '/img/sinful/newest.jpeg',
          targetSrc: 'https://www.sinful.fi/seksilelut/suosikkilelut/uutuusseksilelut',
        },
      ];
    },
  },
};
</script>
